// Imports
import { getStorage, setStorage, deleteStorage } from './storage.js';


//
// Namespace
//

export var ms_api = {
    'var': {
        'store_id': 'msg-',
    },
    'fn': {},
    'callbacks': {}
};


//
// Functions
//

// Entry function for emails
ms_api.fn.getEmails = function(success, failure) {
    var networkSuccessCallback = ms_api.fn.getMailFolders;

    // Set up callbacks
    ms_api['callbacks']['mail'] = {
        'success': success,
        'failure': failure
    };    

    ms_api.fn.configureNetwork(networkSuccessCallback);
};


//
// Helpers
//

// Set up connection to API
ms_api.fn.configureNetwork = function(callback) {
    var application_config = document.querySelector('#ms-graph');
    var application_id = application_config.getAttribute('data-app-id');
    var redirect_url = application_config.getAttribute('data-redirect');

    // Check if helloJS has loaded
    if(typeof(hello) !== 'undefined') {
        // Set up the object
        // Configurations come from aad.js
        hello.init({
            aad : application_id
        },{
            redirect_uri: redirect_url,
            scope: 'Mail.read'
        });

        // Check for existing tokens
        var valid_token = ms_api.fn.isTokenValid();

        if(valid_token) {
            callback();
        } else {
            setTimeout(function(){
                ms_api.fn.loginToNetwork(callback);
            }, 1000);
        }
    }
};

// Store the returned response
ms_api.fn.saveLoginResponse = function(response) {
    var item_key = ms_api['var']['store_id'] + 'login';
    var auth_response = response['authResponse'];

    if(typeof(auth_response) !== 'undefined') {
        setStorage('session', item_key, JSON.stringify(auth_response));
    }
};

// Check if the API token is still valid
ms_api.fn.isTokenValid = function() {
    var item_key = ms_api['var']['store_id'] + 'login';
    var storage_data = getStorage('session', item_key);
    var is_valid = false;

    if(storage_data !== null) {
        var json_data = JSON.parse(storage_data);
        var expiry_datetime = json_data['expires'] * 1000;
        var now_datetime = new Date().getTime();

        if(now_datetime <= expiry_datetime) {
            is_valid = true;
        } else {
            ms_api.fn.logoutOfNetwork();
        }
    }

    return is_valid;
};

// Get token from storage
ms_api.fn.getToken = function() {
    var item_key = ms_api['var']['store_id'] + 'login';
    var storage_data = getStorage('session', item_key);
    var token = '';

    if(storage_data !== null) {
        var json_data = JSON.parse(storage_data);
        var token_type = json_data['token_type'];
        var access_token = json_data['access_token'];
        
        token = token_type + ' ' + access_token;
    }

    return token;
};


//
// HTTP Requests
//

// Connect to the API
ms_api.fn.loginToNetwork = function(callback) {
    var network = 'aad';
    var login_options = {
        display: 'popup',
        domain_hint: 'griffithuni.edu.au'
    };

	// By defining response type to code, the OAuth flow that will return a refresh token to be used to refresh the access token
	// However this will require the oauth_proxy server
	hello(network).login(login_options, ms_api.fn.saveLoginResponse).then(function() {
        callback();
    }, function(e) {
        alert('There was an issue connecting with Microsoft. Please enable popups in your browser.');
    });
};
// Disconnect from the API
ms_api.fn.logoutOfNetwork = function(callback) {
    var network = 'aad';
    var item_key = ms_api['var']['store_id'] + 'login';

    // Delete saved token
    deleteStorage('session', item_key);

	// Removes all sessions, need to call AAD endpoint to do full logout
	hello(network).logout({force: true});
};

// Request all mail folders
ms_api.fn.getMailFolders = function(success, failure) {
    var network = 'aad';
    var mail_endpoint = 'me/mailFolders';

    hello(network).api(mail_endpoint).then(function(data) {
        var string_data = JSON.stringify(data);
        ms_api.fn.requestSuccess(string_data, 'mail');
    }, function(error_object) {
        console.log('Something went wrong: ');
        console.log(error_object);
    });
};

// Success call for MailFolders
ms_api.fn.requestSuccess = function(response, action_type) {
    switch(action_type) {
        case 'mail':
            ms_api.fn.processMailFolders(response);
            break;
    }
};

// Failure for MailFolders
ms_api.fn.requestFailure = function(response) {
    console.log('Mail integration request failure:');
    console.log(response);
};


//
// Process Emails
//

// Process JSON response from API
ms_api.fn.processMailFolders = function(api_response) {
    var json_response = JSON.parse(api_response);
    var all_folders = json_response['value'];

    var target_folder = 'Inbox';
    var unread_emails_count = 0;

    // Check each mail folder for our target
    all_folders.forEach(function(folder, folder_index) {
        var folder_name = folder['displayName'];

        if(folder_name === target_folder) {
            unread_emails_count = folder['unreadItemCount']; 
        }
    });

    // Send unread email count back to application
    ms_api['callbacks']['mail'].success(unread_emails_count);
};
